import type { FC } from 'react';
import { Trans } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { ScCouponPrefilledNotice } from './styled';

export const CouponPrefilledNotice: FC = () => (
  <ScCouponPrefilledNotice>
    <ImageComponent
      alt="ndb-coupon-icon"
      height={44}
      src="/common/ndb_coupon.webp"
      width={44}
    />
    <div className="notice">
      <Trans
        components={{
          1: <span />,
        }}
        i18nKey={'prefilledNdbNotice'}
        ns={'promotions'}
      />
    </div>
  </ScCouponPrefilledNotice>
);
